import React from 'react';
import './liquidacionesModule.css';

export default function LiquidacionesFilterActions({
    disabled = false,
    searchLabel = 'Buscar',
    clearLabel = 'Limpiar',
    showSearchIcon = true
}) {
    return (
        <>
            <button
                type="submit"
                className="btn btn-sm gestion-liquidaciones-btn-buscar"
                disabled={disabled}
            >
                {showSearchIcon && <i className="fa fa-search me-1" aria-hidden="true" />}
                {searchLabel}
            </button>
            <button
                type="reset"
                className="btn btn-sm gestion-liquidaciones-btn-limpiar"
                disabled={disabled}
            >
                {clearLabel}
            </button>
        </>
    );
}
